import {useEffect,useRef} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import styles from './MessageCenter.module.css'
import {
	getContacts,
	selectShow,
	selectMode,
	setShow,
	selectFullscreen,
	setQuery
} from './messageCenterSlice'
import CenteredLoader from '../CenteredLoader/CenteredLoader'
import Messenger from '../Messenger/Messenger'
import Rooms from './Rooms/Rooms'
import Topbar from './Topbar/Topbar'
import ActiveRoom from './ActiveRoom/ActiveRoom'
import RoomCreator from './RoomCreator/RoomCreator'
import {getReactionOptions} from '../reactions/reactionsSlice'

const MessageCenter = ()=>{
	const dispatch = useDispatch()
	const show = useSelector(selectShow)
	const mode = useSelector(selectMode)
	const showFullscreen = useSelector(selectFullscreen)
	const resolveModeComponent = ()=>{
		switch(mode){
			case "ROOM": return <ActiveRoom/>
			case "CREATE_ROOM": return <RoomCreator/>
			case "GROUP": return <Messenger/>
		}
	}
	const backdropRef = useRef()
	useEffect(()=>{
		dispatch(getContacts())
		dispatch(getReactionOptions())
	},[])
	return (
		<div 
			ref={backdropRef}
			onClick={e=>{
				if(!backdropRef.current || e.target !== backdropRef.current) return 
				dispatch(setShow(false))
				//clear out search query on close
				dispatch(setQuery(''))
			}}
			className={[
				styles.MessageCenterContainer,
				show?styles.Show:''
			].join(' ')}
		>
			<div 
				className={[
					showFullscreen?styles.fullscreen:styles.notFullscreen,
					styles.MessageCenter,
					show?styles.Show:''
				].join(' ')}
			>
				<Topbar/>
				<div 
					style={{overflow:'hidden',flex:'1 1 auto'}} 
					className="d-flex align-items-stretch overflow-hidden"
				>
					<Rooms/>
					{resolveModeComponent()}
				</div>
			</div>
		</div>
	)
}

export default MessageCenter